<template>
  <div class="address-wrap">
    <address-read v-if='isPureText' v-bind="{...this.$props}" :value='address'></address-read>
    <address-manage v-else
      @addressChange="addressChange" v-bind="{...this.$props}" :id="address.id"
      :defaultAddressDetail="address" :disabled="disabled" :showPerson="addressEnableContactPerson"
      :showPersonTel="addressEnableContactDetails" :editPersonRequired="required"
      :editPersonTelRequired="required" class="edit-address-wrap">
    </address-manage>
  </div>
</template>

<script>
  import addressManage from './components/address.vue'
  import addressRead from './components/address-read.vue'
  import {addressProps} from './index'

  export default {
    name: 'sy-address',
    props: addressProps,
    model: {
      event: 'change',
      prop: 'address'
    },
    methods: {
      addressChange (address) {
        // console.log('address', JSON.parse(JSON.stringify(address)))
        // address.countyCode = address.areaCode // 区县
        // address.countyName = address.areaName // 区县
        // address.townCode = address.streetCode // 街道、乡镇
        // address.townName = address.streetName // 街道、乡镇
        this.$emit('change', address)
        // this.$emit('validateField', this.field.apiName)
      }
    },
    components: {
      addressManage,
      addressRead
    }
  }
</script>
